import Top5MonthlyIncidentsGraph from './Top5MonthlyIncidentsGraph';

export default Top5MonthlyIncidentsGraph;
